/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { Splitter } from "@progress/kendo-react-layout";
import { getSelectedState, Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import * as API from "../../framework/API/api";
import { BOOKINGSTATUS, ENTITYNAME, FILEURL, LOCALSTORAGE_KEY, LOGEVENT, MODULE, RECONCILESTATUS, SOCKET_ACTION, SOCKET_EVENTS, TOAST_TYPES } from "../../framework/constant/constant";
import ActionButton from "../../framework/forms/helpercomponents/buttons/ActionButton";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { TimeCell } from "../../framework/forms/helpercomponents/CustomGridCells/TimeCell";
import moment from "moment";
import { getter } from "@progress/kendo-data-query";
import { ContextMenu } from 'primereact/contextmenu';
import { utility } from "../../framework/utility/utilityProvider";
import CustomLegend from "../../components/CustomLegend";
import { useTranslation } from "../../locale/useTranslation";
import { useNavigate } from "react-router-dom";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import { EditPageHeader } from "../../components/EditPageHeader";
import { TimePickerWithFormat } from "../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat";
import { Checkbox } from "@progress/kendo-react-inputs";
import { DateOnlyCell } from "../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import socket from "../../framework/socket/socket";
import BossDialog from "../../components/BossDialog";
import { PlanningHelper } from "../Planning/helper/PlanningHelper";
import ToastNotification from "../../components/ToastNotification";

const SELECTED_FIELD = "selected";
const DATA_ITEM_KEY = "_id";
const idGetter = getter(DATA_ITEM_KEY);

const TitleCell = (props) => {
    const field = props.field || "";
    const rawValue = (field ? getter(field)(props.dataItem) : null) ?? props.dataItem.MediaTitle ?? props.dataItem.mediaEpisode?.Title ?? props.dataItem.Title ?? "";
    const value = rawValue ? String(rawValue) : "";

    const displayValue = value.length >= 28 ? `${value.substr(0, 27)}...` : value;

    return <td title={value}>
        {displayValue}
    </td>;
};

const IdCell = (props) => {
    return <td>{props.dataItem.ID || props.dataItem.AssetId || ""}</td>;
};

const SecondaryEventReconciliation = () => {

    const lang = useTranslation();
    const userData = utility.getValue(LOCALSTORAGE_KEY.userData);
    const reconsiledData = [
        { SID: 0, Description: "All", IsReconciled: '' },
        { SID: 1, Description: "Reconsiled", IsReconciled: true },
        { SID: 2, Description: "Non Reconsiled", IsReconciled: false }
    ]

    const blankDataItem = {
        FromDate: moment(new Date()).format("YYYY-MM-DD"),
        Channel: {},
        Reconsile: reconsiledData[0]
    }

    const blankoffsetDataItem = {
        OffsetTimePlus: '00:00:00:00',
        OffsetTimeMinus: '00:00:00:00',
        IgnoreDuration: false
    }
    const [showOffSetSetting, setShowOffSetSetting] = useState(false);

    const [dataItem, setDataItemObject] = useState(blankDataItem);
    const dataItemRef = useRef(blankDataItem);

    const setDataItem = (di) => {
        dataItemRef.current = di;
        setDataItemObject(di);
    }

    const [offsetdataItem, setOffsetDataItem] = useState(blankoffsetDataItem);

    const [scheduleGridData, _setScheduleGridData] = useState([]);
    const schedulerDataRef = useRef([]);
    const setScheduleGridData = (data) => {
        schedulerDataRef.current = data;
        _setScheduleGridData(data);
    }

    const [asRunGridData, _setAsRunGridData] = useState([]);
    const asrunDataRef = useRef([]);
    const setAsRunGridData = (data) => {
        asrunDataRef.current = data;
        _setAsRunGridData(data);
    }

    const [channel, setChannel] = useState([]);

    //selected item
    const [selectedScheduleState, setSelectedScheduleState] = useState({});
    const [selectedAsRunState, setSelectedAsRunState] = useState({});
    const [selectedScheduleItem, setSelectedScheduleItem] = useState([]);
    const [selectedAsRunItem, setSelectedAsRunItem] = useState([]);

    //Parallel Scrolling
    const scheduleScroll = useRef(null);
    const asRunScroll = useRef(null);
    const parallelScrollRef = useRef(false);
    const [isScrollTogether, setIsScrollTogether] = useState(true);

    //UI variables
    const [scheduleFilterGridData, setScheduleFilterGridData] = useState([]); //temp var to store filtered object 
    const [asRunFilterGridData, setAsRunFilterGridData] = useState([]); //temp var to store filtered object 
    const [scheduleInfo, setScheduleInfo] = useState({ total: 0, reconciled: 0, prototypes: 0 });
    const [asrunInfo, setAsrunInfo] = useState({ total: 0, reconciled: 0, prototypes: 0 });

    //footer status 
    const [loadingStatus, setLoadingStatus] = useState(
        `${lang.no_record_found_error_message}`
    );
    const navigate = useNavigate();

    useEffect(() => {
        loadcombo();
    }, []);


    const loadcombo = async () => {

        let channelRes = await API.getValidChannels(ENTITYNAME.Channel);
        setChannel(channelRes.data);
        setDataItem({ ...blankDataItem, Channel: utility.getDefaultItem(channelRes.data) })

        let offsetsettingRes = await API.getDataLookup(ENTITYNAME.ReconsileSetting);
        setOffsetDataItem(offsetsettingRes.data[0] ? { ...offsetsettingRes.data[0] } : blankoffsetDataItem)

    }

    const cm = useRef();//FOR SCHEDULE AND ASRUN RIGHT CLICK : CONTEXT MENU
    const ref = useRef();

    const gridRowRender = (tr, props) => {

        const green = { backgroundColor: "#609EA2", };
        const defaultColor = { backgroundColor: "rgb(255, 255, 224)", };
        const orange = { backgroundColor: "rgb(255, 153, 51)", };


        const trProps = {
            style: props.dataItem.IsReconciled ? (props.dataItem.ReconciledStatus == RECONCILESTATUS.AutoReconciled ? green : orange) : defaultColor,
            onContextMenu: (e) => { ref.current = props.dataItem; cm.current.show(e) },
        };
        // console.log(props.dataItem.ReconciledStatus);
        return React.cloneElement(tr, { ...trProps }, tr.props.children);
    };


    const onChange = (e) => {

        setDataItem({ ...dataItem, [e.target.name]: e.target.value });

        filterGrids();

    }

    const onChangeOffset = (e) => {
        if (e.target.name == "IgnoreDuration") {
            setOffsetDataItem({ ...offsetdataItem, IgnoreDuration: !offsetdataItem.IgnoreDuration });
            console.log(!offsetdataItem.IgnoreDuration)
        }
        else {
            setOffsetDataItem({ ...offsetdataItem, [e.target.name]: e.target.value });
        }


    }

    const resetBothGrids = () => {
        setScheduleGridData([]);
        setAsRunGridData([]);
        setAsRunFilterGridData([]);
        setScheduleFilterGridData([]);
    }

    const isValid = () => {

        if (!utility.isValidDate(dataItem.FromDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_select_from_date_error_message}` });
            return false;
        }

        if (dataItem.Channel == undefined || Object.keys(dataItem.Channel).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_select_channel_error_message}` });
            return false;
        }
        return true;
    }

    const loadScheduledata = async () => {

        // empty
        resetBothGrids();

        if (!isValid()) return;

        setDataItem({ ...dataItem, Reconsile: { SID: 0, Description: "All", IsReconciled: '' } });

        setLoadingStatus(`${lang.data_loading_error_message}`);

        try {

            const preferenceData = utility.getValue(LOCALSTORAGE_KEY.planningpreference);
            // const offSetHours = new Date(preferenceData?.data[0]?.value?.TimeZone?.DayStartTime ?? 0).getUTCHours();
            const offSetHours = new Date(PlanningHelper.getDayStartTime([dataItem.Channel]) ?? 0).getUTCHours();
            const offsetTime = offSetHours * 3600000;
            var scheduleStart = new Date(dataItem.FromDate).getTime() + offsetTime;

            var payload = {
                ScheduleDate: scheduleStart,
                ScheduleEndDate: new Date(dataItem.FromDate).getTime() + offsetTime + (24 * 3600000),
                channelSID: dataItem.Channel.SID,
                isWithOutHeaders: true
            };

            const json = await API.getScheduling(payload);
            console.log(json);

            if (json.data == undefined || json.data.length == 0) {
                setLoadingStatus(`${lang.no_record_found_error_message}`);
                ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: `${lang.no_data_found_scheduling_reconciliation_error_message}` });
                return;
            }

            //remove header and breaks
            const scheduleWithoutHeader = json.data.filter((item) => item.ParentProgramSchedule_id != null && (item.IsBreak == undefined || item.IsBreak == false));
            const sortedSchedule = scheduleWithoutHeader.sort((a, b) => a.SlotDateTime - b.SlotDateTime);

            let prototypeScheduleData = [];
            let serial = 1;
            sortedSchedule.forEach((item) => {
                const mediaTitle = item.mediaEpisode?.Title || item.mediaEpisode?.EpisodeTitle || item.mediaEpisode?.Description || item.segments?.[0]?.MediaEpisode?.Title || item.segments?.[0]?.MediaEpisode?.EpisodeTitle || item.Title || "";

                if (item.Prototypes && item.Prototypes.length > 0) {
                    item.Prototypes.forEach((proto) => {
                        prototypeScheduleData.push({
                            ...item,
                            SerielNo: serial++,
                            _id: proto._id || `${item._id}_${proto.SID}`,
                            scheduleItem_id: item._id,
                            Prototype: proto,
                            Prototype_id: proto._id,
                            PrototypeSID: proto.SID,
                            PrototypeID: proto.ID,
                            ID: proto.ID,
                            Name: proto.Name,
                            ProtoTypeSource: proto.ProtoTypeSource,
                            StartOffset: proto.StartOffset,
                            EndOffset: proto.EndOffset,
                            StartTriggerType: proto.StartTriggerType,
                            EndTriggerType: proto.EndTriggerType,
                            Content: proto.Content,
                            Duration: (proto.EndOffset !== undefined && proto.StartOffset !== undefined) ? (proto.EndOffset - proto.StartOffset) : item.Duration,
                            IsReconciled: proto.IsReconciled !== undefined ? proto.IsReconciled : (item.IsReconciled || false),
                            ReconciledStatus: proto.ReconciledStatus !== undefined ? proto.ReconciledStatus : (item.ReconciledStatus || 0),
                            ProgramScheduleReconcile_id: proto.ProgramScheduleReconcile_id || item.ProgramScheduleReconcile_id || "",
                            MediaTitle: mediaTitle,
                            mediaEpisode: item.mediaEpisode,
                        });
                    });
                }
            });

            if (prototypeScheduleData.length === 0) {
                setScheduleGridData([]);
                setScheduleFilterGridData([]);
                schedulerDataRef.current = [];
                setLoadingStatus(`${lang.no_record_found_error_message}`);
                ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: `${lang.no_data_found_scheduling_reconciliation_error_message}` });
                return;
            }

            setScheduleGridData(prototypeScheduleData);
            schedulerDataRef.current = prototypeScheduleData;
            setScheduleFilterGridData(prototypeScheduleData);
            loadAsRun(prototypeScheduleData, payload);

        } catch (error) {
            console.log("error", error);
        }

    }

    const loadAsRun = async (scheduleData, schedulePayload) => {


        if (scheduleData.length == 0) {
            setAsRunGridData([]);
            setAsRunFilterGridData([]);
            setAsrunInfo({ total: 0, reconciled: 0, prototypes: 0 });
            setLoadingStatus(`${lang.no_record_found_error_message}`);
            return;
        }

        var res = await API.getAsrunData(schedulePayload);

        console.log(res);

        if (res.success) {
            // if IsReconcile is Null It SHould be treated as False.
            setLoadingStatus(`${lang.data_loading_error_message}`);
            var data = [];
            res.data.sort((a, b) => a.SlotDateTime - b.SlotDateTime).map((item, index) => {
                if (item.IsReconciled == undefined) {
                    data.push({ TempSNo: index + 1, ...item, IsReconciled: false });
                } else {
                    data.push({ TempSNo: index + 1, ...item });
                }
            });

            setAsRunGridData(data);
            setAsRunFilterGridData(data);
            updateInfo();
            setLoadingStatus(`${lang.no_record_found_error_message}`);

            // if (data.length > 0) {
            //     ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `${lang.schedule_and_as_run_data_load_successfully_scheduling_reconciliation_success_message}` + res.message })
            //     setLoadingStatus(`${lang.no_record_found_error_message}`);
            // }

        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.error_while_loading_as_run_data_scheduling_reconciliation_error_message + res.message });

        }

    }

    const MyTimeCell = (props) => {
        return <TimeCell {...props} />;
    }

    const onScheduleSelectionChange = (event) => {

        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedScheduleState,
            dataItemKey: DATA_ITEM_KEY
        });
        setSelectedScheduleState(newSelectedState);

        var selectedItem = scheduleGridData.filter((item) => item._id == Object.keys(newSelectedState)[0])
        setSelectedScheduleItem(selectedItem);

        //for automatically select asRun on selecting program schedule on the basis of ProgramScheduleReconcile_id
        if (selectedItem[0]?.IsReconciled) {

            console.log(selectedItem[0]);
            setSelectedAsRunState({
                [selectedItem[0].ProgramScheduleReconcile_id]: true
            });
            setSelectedAsRunItem(asRunGridData.filter((item) => item._id == selectedItem[0].ProgramScheduleReconcile_id));
        }
        else if (selectedItem[0]) {
            var nearestAsRun = getNearestAsRun(selectedItem);
            setSelectedAsRunState({
                [nearestAsRun[0]?._id]: true
            });
            setSelectedAsRunItem(asRunGridData.filter((item) => item?._id == nearestAsRun[0]?._id));
        }

    };

    const getNearestAsRun = (selectedItem) => {

        const pOffset = utility.convertStringWithFramesToMilliseconds(offsetdataItem.OffsetTimePlus);
        const nOffset = utility.convertStringWithFramesToMilliseconds(offsetdataItem.OffsetTimeMinus);

        return asRunGridData.filter((item) => {
            const asRunProtoId = item.ID || item.AssetId;
            const scheduleProtoId = selectedItem[0]?.ID || selectedItem[0]?.PrototypeID;
            if (asRunProtoId && scheduleProtoId && asRunProtoId == scheduleProtoId && !item.IsReconciled && item.SlotDateTime >= selectedItem[0].SlotDateTime - nOffset && item.SlotDateTime <= selectedItem[0].SlotDateTime + pOffset) {
                return item;
            }
        });
    }

    //old
    const autoReconcile = () => {
        if (scheduleGridData.length > 0) {
            scheduleGridData.map(data => {
                if (!data.IsReconciled) {
                    var nearestAsRun = getNearestAsRun([data]);
                    if (nearestAsRun.length > 0) {
                        ReconcileSelectedItems([data], nearestAsRun, RECONCILESTATUS.AutoReconciled, true);
                    }
                }
            })
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `${lang.auto_recocile_successfully_scheduling_reconciliation_success_message}` })
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_load_first_scheduling_reconciliation_error_message });
        }
        updateInfo();
    }


    //new
    // const autoReconcile = async() => {

    //     //payload for fetch data on backend
    //     const preferenceData = utility.getValue(LOCALSTORAGE_KEY.planningpreference);
    //     const offSetHours = new Date(preferenceData?.data[0]?.value?.TimeZone?.DayStartTime ?? 0).getUTCHours();
    //     const offsetTime = offSetHours * 3600000;

    //     console.log(dataItem.Channel.SID)

    //     var scheduleStart = new Date(dataItem.FromDate).getTime() + offsetTime;

    //     var payload = {
    //         ScheduleDate: scheduleStart,
    //         ScheduleEndDate: new Date(dataItem.FromDate).getTime() + offsetTime + (24 * 3600000),
    //         channelSID: dataItem.Channel.SID,
    //         isWithOutHeaders: true,
    //         offSetDataItem : offsetdataItem
    //     };

    //     var matchedResponse = await API.autoReconcilation(payload);
    //     console.log(matchedResponse);
    //     if(matchedResponse.success){
    //         setScheduleGridData(matchedResponse.scheduleData.data);
    //         setAsRunGridData(matchedResponse.asRunData.data);
    //         setScheduleFilterGridData(matchedResponse.scheduleData.data);
    //         setAsRunFilterGridData(matchedResponse.asRunData.data);
    //         ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `${lang.auto_recocile_successfully_scheduling_reconciliation_success_message}` })
    //     }else{
    //         ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${matchedResponse.message}` })
    //     }
    //     updateInfo();
    // }

    const openImportAsRun = () => {
        navigate("/home/ImportAsRun");
    }

    const onAsRunSelectionChange = (event) => {
        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedAsRunState,
            dataItemKey: DATA_ITEM_KEY
        });
        setSelectedAsRunState(newSelectedState);

        var selectedItem = asRunGridData.filter((item) => item._id == Object.keys(newSelectedState)[0])
        setSelectedAsRunItem(selectedItem);

    };

    const ReconcileSelectedItems = (scheduleItemToMatch = null, asrunItemToMatch = null, reconType = RECONCILESTATUS.ForceMatch, isFromAutoReconcile = false) => {

        console.log(scheduleItemToMatch);

        if (scheduleItemToMatch == null || asrunItemToMatch == null) {
            scheduleItemToMatch = selectedScheduleItem;
            asrunItemToMatch = selectedAsRunItem;
        }

        if (!asRunGridData || asRunGridData.length == 0) {
            contextMenuCancel();
            if (!isFromAutoReconcile) ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.no_as_run_found_error_message}` });
            return;
        }

        //VALIDATIONS 
        if (scheduleItemToMatch == undefined || scheduleItemToMatch.length == 0 || asrunItemToMatch == undefined || asrunItemToMatch.length == 0) {
            if (!isFromAutoReconcile)
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.select_first_scheduling_reconciliation_error_message });
            return;
        }
        if ((scheduleItemToMatch != undefined && scheduleItemToMatch[0]?.IsReconciled) || (asrunItemToMatch != undefined && asrunItemToMatch[0]?.IsReconciled)) {
            contextMenuCancel();
            if (!isFromAutoReconcile)
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.already_reconsiled_scheduling_reconciliation_error_message });
            return;
        }

        const scheduleProtoId = scheduleItemToMatch[0]?.ID || scheduleItemToMatch[0]?.PrototypeID;
        const asrunProtoId = asrunItemToMatch[0]?.ID || asrunItemToMatch[0]?.AssetId;

        if (scheduleProtoId != asrunProtoId) {
            contextMenuCancel();
            if (!isFromAutoReconcile)
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.select_item_have_different_assetid_scheduling_reconciliation_error_message });
            return;
        }

        //IF IGNORE DURATION IS NOT CHECKED THEN WE HAVE TO MATCH THE EXACT DURATION
        console.log(offsetdataItem);
        if (offsetdataItem.IgnoreDuration == undefined || offsetdataItem.IgnoreDuration == false) {
            var scheduelData = scheduleGridData.find(x => x._id == scheduleItemToMatch[0]._id);

            var asRunData = {};
            for (var i = 0; i < asrunItemToMatch.length; i++) {
                asRunData = asRunGridData.find(x => x._id == asrunItemToMatch[i]._id);
                if (asRunData != undefined && asRunData._id != undefined) {
                    break;
                }

            }

            if (scheduelData && asRunData && scheduelData.Duration != asRunData.ActualDuration) {
                contextMenuCancel();
                if (!isFromAutoReconcile) ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: `${lang.duration_mismatch_error_message}` });
                return;
            }


        }

        scheduleGridData.map((item, index) => {
            if (item._id == scheduleItemToMatch[0]._id) {
                var updatedScheduleItem = {
                    ...item,
                    ReconciledStatus: reconType,
                    IsReconciled: true,
                    ActualOnAir: asrunItemToMatch[0].SlotDateTime,
                    ProgramScheduleReconcile_id: asrunItemToMatch[0]._id.toString()
                }
                scheduleGridData.splice(index, 1, updatedScheduleItem);
                setScheduleGridData([...scheduleGridData]);
            }
        })
        setSelectedScheduleItem({});
        setSelectedScheduleState({});

        asRunGridData.map((item, index) => {
            if (item._id == asrunItemToMatch[0]._id) {
                var updatedAsRunItem = {
                    ...item,
                    ReconciledStatus: reconType,
                    IsReconciled: true,
                    ProgramSchedule_id: scheduleItemToMatch[0]._id.toString()
                }
                asRunGridData.splice(index, 1, updatedAsRunItem);
                setAsRunGridData([...asRunGridData]);
            }
        })
        setSelectedAsRunItem({});
        setSelectedAsRunState({});
        updateInfo();

        filterGrids();

    }

    const updateInfo = () => {

        // Schedule Side
        var reconciledItems = schedulerDataRef.current.filter((item) => item.IsReconciled == true);
        setScheduleInfo(old => ({ ...old, total: schedulerDataRef.current.length, reconciled: reconciledItems.length, prototypes: schedulerDataRef.current.length }));

        // as run Side
        var reconciledAsruns = asrunDataRef.current.filter((item) => item.IsReconciled == true);
        setAsrunInfo(old => ({ ...old, total: asrunDataRef.current.length, reconciled: reconciledAsruns.length, prototypes: asrunDataRef.current.length }));

    }

    const offsetSettingdata = () => {

        setShowOffSetSetting(true);
    }

    const forceUnMatch = () => {

        if (selectedScheduleItem[0] == undefined || selectedAsRunItem[0] == undefined) {

            contextMenuCancel();
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_schedule_and_as_run_item_scheduling_reconciliation_error_message });
            return;
        }

        //VALIDATIONS 
        if (!selectedScheduleItem[0].IsReconciled || !selectedAsRunItem[0].IsReconciled) {
            contextMenuCancel();
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.select_item_is_not_reconsiled_scheduling_reconciliation_error_message });
            return;
        }

        if (selectedScheduleItem[0]._id.toString() != selectedAsRunItem[0].ProgramSchedule_id) {
            contextMenuCancel();
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.select_schedule_and_asrun_item_not_reconciled_together_scheduling_reconciliation_error_message });
            return;
        }

        if (selectedScheduleItem[0].booking && selectedScheduleItem[0].booking.BookingStatusSID > BOOKINGSTATUS.Reconciled) {
            contextMenuCancel();
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.select_schedule_item_already_billed_error_message}` });
            return;
        }

        scheduleGridData.map((item, index) => {
            if (item._id == Object.keys(selectedScheduleState)[0]) {
                var updatedScheduleItem = {
                    ...item,
                    ReconciledStatus: RECONCILESTATUS.None,
                    IsReconciled: false,
                    ActualOnAir: null,
                    ProgramScheduleReconcile_id: null
                }
                scheduleGridData.splice(index, 1, updatedScheduleItem);
                setScheduleGridData([...scheduleGridData]);
            }
        })
        setSelectedScheduleItem({});
        setSelectedScheduleState({});

        asRunGridData.map((item, index) => {
            if (item._id == Object.keys(selectedAsRunState)[0]) {
                var updatedAsRunItem = {
                    ...item,
                    ReconciledStatus: RECONCILESTATUS.None,
                    IsReconciled: false,
                    ProgramSchedule_id: null
                }
                asRunGridData.splice(index, 1, updatedAsRunItem);
                setAsRunGridData([...asRunGridData]);

            }
        })
        setSelectedAsRunItem({});
        setSelectedAsRunState({});
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `${lang.force_unmatch_successfully_scheduling_reconciliation_success_message}` });
        updateInfo();

        filterGrids();
    }

    const filterGrids = () => {

        // filtering schedule by reconciled status selected
        var filteredSchedules = schedulerDataRef.current.filter((item) =>
            (dataItemRef.current.Reconsile.SID == 0 || item.IsReconciled == dataItemRef.current.Reconsile.IsReconciled));
        setScheduleFilterGridData(() => filteredSchedules);


        // filtering as run side data with reconcile status
        var filteredAsruns = asrunDataRef.current.filter((item) =>
            (dataItemRef.current.Reconsile.SID == 0 || item.IsReconciled == dataItemRef.current.Reconsile.IsReconciled));
        setAsRunFilterGridData(() => filteredAsruns);

    }

    //clear selected Item 
    const contextMenuCancel = () => {

        setSelectedScheduleItem({});
        setSelectedScheduleState({});
        setSelectedAsRunItem({});
        setSelectedAsRunState({});

    }

    const refreshLocalStatusforOtheruser = () => {
        const date = new Date(dataItem.FromDate)
        socket()?.emit(SOCKET_EVENTS.onSocketData, {
            action: SOCKET_ACTION.SCHEDULE_LOCK_UPDATE,
            module: MODULE.SCHEDULING,
            data: {
                selectedChannelSID: dataItem.Channel.SID, selectedScheduleDate: date.getTime()
            },
            user: {
                _id: userData._id,
                name: userData.name
            }
        });
        socket()?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.PLANNING_REFRESH, module: MODULE.PLANNING, data: { scheduleScheduleStartDate: date.getTime(), scheduleScheduleEndDate: date.getTime(), channelSID: dataItem.Channel.SID } });
    }

    const saveReconciliationStatus = async () => {

        if (scheduleGridData.length == 0) {
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: `${lang.no_data_schedule_to_save_scheduling_reconciliation_error_message}` })
            return;
        }
        if (asRunGridData.length == 0) {
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: `${lang.no_data_asrun_to_save_scheduling_reconciliation_error_message}` })
            return;
        }

        var saveData = {
            programSchedule: scheduleGridData,
            asRun: asRunGridData,
        }
        console.log(saveData);
        var res = await API.saveReconciliationStatus(saveData);

        const channelObj = {
            _id: dataItem.Channel._id,
            name: dataItem.Channel.FullChannelName,
        }
        const date = new Date(dataItem.FromDate)

        if (res.success) {
            //LOCK PLANNING AND SCHEDULE WHEN RECONCILED SUCCESSFULLY
            let lockSchedule = await utility.lockUnlockPlaylist(channelObj, date.getTime(), MODULE.SCHEDULING);
            let logScheduleData = {
                event: LOGEVENT.LOCK_SCHEDULE,
                module: MODULE.SCHEDULING,
                data: {
                    _id: userData._id,
                    name: userData.name
                },
                message: LOGEVENT.LOCK_SCHEDULE
            };
            API.SaveLogs(logScheduleData);
            let lockPlanning = await utility.lockUnlockPlaylist(channelObj, date.getTime(), MODULE.PLANNING);
            let logPlanningData = {
                event: LOGEVENT.LOCK_PLANNING,
                module: MODULE.PLANNING,
                data: {
                    _id: userData._id,
                    name: userData.name
                },
                message: LOGEVENT.LOCK_PLANNING
            }
            API.SaveLogs(logPlanningData);
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `${lang.saved_successfully_scheduling_reconciliation_success_message}` })
            refreshLocalStatusforOtheruser();
        } else {
            console.log(res.message)
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message })
        }
        // console.log(res);
        // if(!res.success) return;
    }

    const onScheduleScroll = (event) => {
        if (!isScrollTogether) return;

        const { scrollLeft, scrollTop } = event.nativeEvent.target;

        if (parallelScrollRef.current) {
            parallelScrollRef.current = false;
            return;
        }

        parallelScrollRef.current = true;
        asRunScroll.current.containerRef.current.scrollTo(scrollLeft, scrollTop);
    };

    const onAsRunScroll = (event) => {
        if (!isScrollTogether) return;

        const { scrollLeft, scrollTop } = event.nativeEvent.target;

        if (parallelScrollRef.current) {
            parallelScrollRef.current = false;
            return;
        }

        parallelScrollRef.current = true;
        scheduleScroll.current.containerRef.current.scrollTo(scrollLeft, scrollTop);

    };
    const isValidforOffSetSetting = () => {
        if (offsetdataItem.OffsetTimeMinus === undefined || offsetdataItem.OffsetTimeMinus === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_OffSet_Time_Minus_error_message });
            return false;
        }
        if (offsetdataItem.OffsetTimePlus === undefined || offsetdataItem.OffsetTimePlus === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_offSet_time_plus_error_message });
            return false;
        }
        return true;
    }

    const onSaveOffSetSetting = async () => {
        if (isValidforOffSetSetting()) {

            var localData = {
                SID: offsetdataItem.SID ?? 0,
                OffsetTimeMinus: offsetdataItem.OffsetTimeMinus,
                OffsetTimePlus: offsetdataItem.OffsetTimePlus,
                IgnoreDuration: offsetdataItem.IgnoreDuration ? true : false,
            }

            var res = await API.saveData(ENTITYNAME.ReconsileSetting, localData);
            console.log(localData);
            if (res.success) {
                // navigate(-1);
                setShowOffSetSetting(false);
                return;
            }
            else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            }
            setShowOffSetSetting(false);
            utility.deleteLocalStorageItem(ENTITYNAME.ReconsileSetting)
            setOffsetDataItem(blankoffsetDataItem);
        }
    }

    const downloadExcel = async () => {

        if (scheduleGridData.length == 0) {
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: `${lang.no_data_schedule_to_download_error_message}` })
            return;
        }

        console.log(scheduleGridData);
        console.log(blankoffsetDataItem);
        var saveData = scheduleGridData.map((x, index) => {
            return {
                SerielNo: index + 1,
                Date: moment(new Date(x.SlotDateTime)).utc().format("YYYY-MM-DD"),
                Time: utility.convertMilisecondsToStringWithFrames(x.SlotDateTime),
                PrototypeName: x.Name || "",
                PrototypeID: x.ID || "",
                Source: x.ProtoTypeSource?.Name || "",
                ParentTitle: x.MediaTitle || x.mediaEpisode?.Title || "",
                StartOffset: utility.convertMilisecondsToStringWithFrames(x.StartOffset || 0),
                EndOffset: utility.convertMilisecondsToStringWithFrames(x.EndOffset || 0),
                Duration: utility.convertMilisecondsToStringWithFrames(x.Duration || 0),
                ReconciledStatus: x.IsReconciled ? "Reconciled" : "Not Reconciled",
                ReconciledOffSet: blankoffsetDataItem.OffsetTimeMinus != "00:00:00:00" && blankoffsetDataItem.OffsetTimePlus != "00:00:00:00" ? "Yes" : blankoffsetDataItem.IgnoreDuration ? "NA" : "No"
            }
        })

        console.log(saveData);
        var res = await API.exportCSV(saveData);
        console.log(res.data);
        if (res.success) {
            window.open(FILEURL().BASEURL + 'downloadReport/' + res.data)
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `${lang.successfully_download_success_message}` });
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }


    return <div style={{ height: "70%" }}>

        <div className="row" style={{ fontSize: "10px", margin: "2px", border: '1px solid black', borderRadius: '5px!important' }}>
            <div className="col-12">
                <div className="row mt-1">
                    <div className="col-3">
                        <div className="form-group">
                            <label htmlFor="">{lang.from_date_label} *</label>
                            <input
                                type="date"
                                className="form-control form-control-sm"
                                name="FromDate"
                                value={dataItem.FromDate}
                                onChange={onChange}
                            />
                        </div>
                    </div>
                    <div className="col-3">
                        <label htmlFor="TabView">{lang.channel_label} *</label>
                        <DropDownList
                            style={{
                                backgroundColor: "white",
                            }}
                            data={channel}
                            name="Channel"
                            textField="FullChannelName"
                            dataItemKey="_id"
                            value={dataItem.Channel}
                            onChange={onChange}
                        />
                    </div>
                    <div className="row ml-1" style={{ marginTop: "18px", padding: "0px 0px 15px 0px" }}>
                        <ActionButton btnColor={'info'} style={{ borderRadius: '5px' }} title={lang.load_button_tooltip} name={lang.load_button_text} onClick={loadScheduledata} />
                        <ActionButton title={lang.save_button_tooltip} style={{ borderRadius: '5px' }} name={lang.save_button_text} onClick={saveReconciliationStatus} />
                        <RoundButton style={{ marginLeft: '5px' }} icon={'check-square'} title={lang.auto_reconcile_button_tooltip} onClick={autoReconcile} />
                        <RoundButton style={{ marginLeft: '5px' }} icon={'upload'} title={lang.import_as_run_button_tooltip} onClick={openImportAsRun} />
                        <RoundButton style={{ marginLeft: '5px' }} icon={'download'} title={lang.download_button_tooltip} onClick={downloadExcel} />
                        <RoundButton style={{ marginLeft: '5px' }} icon={'slack'} title={lang.ref_off_setting_label} onClick={offsetSettingdata} />
                    </div>
                    <div className="col" style={{ textAlign: "right" }}>
                        {/* checkbox */}
                        <Checkbox
                            style={{ borderColor: "black" }}
                            name="ScrollTogether"
                            label={lang.scroll_together_label}
                            labelPlacement="before"
                            checked={isScrollTogether}
                            onChange={() => { setIsScrollTogether(!isScrollTogether) }}
                        />
                    </div>

                </div>
                <div className="row">

                    <div className="col-3">
                        <div className="form-group">
                            <label htmlFor="TabView">{lang.reconciled_label} *</label>
                            <DropDownList
                                style={{
                                    backgroundColor: "white",
                                }}
                                data={reconsiledData}
                                defaultValue={reconsiledData[0]}
                                name="Reconsile"
                                textField="Description"
                                dataItemKey="SID"
                                value={dataItem.Reconsile}
                                onChange={onChange}
                                validator={(value) => value ? "" : "Please select the value"}
                            />
                        </div>
                    </div>

                    <div className="col mt-4" >
                        <div className="row" style={{ textAlign: 'right' }}>
                            <div className="col">&nbsp;</div>

                            <div className="mr-1">
                                {/* <p style={{margin : '0px',display:'flex'}}><div style={{width : '15px' ,height : '15px',margin:"0px" ,padding:"0px",backgroundColor : 'rgb(0, 255, 0)',margin:'02px 05px'}}></div> */}
                                <CustomLegend title={lang.reconciled_r_label} onHoverTitle={lang.reconciled_label} titleColor="black" tileBackColor="#609EA2"></CustomLegend>
                                {/* </p> */}

                            </div>
                            <div className="mr-1">
                                {/* <p style={{margin : '0px',display:'flex'}}><div style={{width : '15px' ,height : '15px',margin:"0px" ,padding:"0px",backgroundColor : 'rgb(255, 255, 224)',margin:'02px 05px'}}></div> */}
                                <CustomLegend title={lang.non_reconciled_nr_label} onHoverTitle={lang.non_reconciled_label} titleColor="black" tileBackColor="rgb(255, 255, 224)" ></CustomLegend>
                                {/* </p> */}
                            </div>
                            <div className="mr-1">
                                {/* <p style={{margin : '0px',display:'flex'}}><div style={{width : '15px' ,height : '15px',margin:"0px" ,padding:"0px",backgroundColor : 'rgb(255, 153, 51)',margin:'02px 05px'}}></div> */}
                                <CustomLegend title={lang.force_match_fm_label} onHoverTitle={lang.force_match_label} tileBackColor="rgb(255, 153, 51)" ></CustomLegend>
                                {/* </p> */}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div className="row" style={{ height: "25px", fontSize: "12px", marginTop: "05px" }}>
            <div className="col-2">
                {lang.total_label} {scheduleInfo.total}
            </div>
            <div className="col-2" >
                {lang.reconciled_label}: {scheduleInfo.reconciled}
            </div>
            <div className="col-2">
                {lang.prototypes_label || "Prototypes"}: {scheduleInfo.prototypes}
            </div>

            <div className="col-2">
                {lang.total_label} {asrunInfo.total}
            </div>
            <div className="col-2">
                {lang.reconciled_label}: {asrunInfo.reconciled}
            </div>
            <div className="col-2">
                {lang.prototypes_label || "Prototypes"}: {asrunInfo.prototypes}
            </div>
        </div>

        <Splitter
            style={{ height: "100%" }}

        >

            {/* parent grid */}
            <>
                <div style={{ textAlign: 'center', fontWeight: 'bold' }}>{lang.schedule_label}</div>
                <Grid data={scheduleFilterGridData.map((item) => ({
                    ...item,
                    [SELECTED_FIELD]: selectedScheduleState[idGetter(item)]
                    // "selected" : true
                }))}
                    selectedField={SELECTED_FIELD}
                    selectable={true}
                    dataItemKey={DATA_ITEM_KEY}
                    onSelectionChange={onScheduleSelectionChange}
                    rowRender={gridRowRender}
                    style={{ height: "95%" }}
                    ref={scheduleScroll}
                    onScroll={onScheduleScroll}
                >
                    <GridNoRecords>{loadingStatus}</GridNoRecords>
                    <Column field="SerielNo" title={lang.sno_column} width={70} />
                    <Column field="SlotDateTime" title={lang.date_column} cell={DateOnlyCell} width={100} />
                    <Column field="SlotDateTime" title={lang.time_column} cell={MyTimeCell} width={100} />
                    <Column field="Name" title={lang.name_column || "Name"} width={160} />
                    <Column field="ID" title={lang.id_column || "ID"} width={110} />
                    <Column field="ProtoTypeSource.Name" title={lang.protoType_source_column || lang.source_column} width={130} />
                    <Column field="StartOffset" title={lang.start_offset_column || "Start Offset"} cell={MyTimeCell} width={100} />
                    <Column field="EndOffset" title={lang.end_offset_column || "End Offset"} cell={MyTimeCell} width={100} />
                    <Column field="MediaTitle" title={lang.title_column} width={220} cell={TitleCell} />
                    <Column field="Duration" title={lang.duration_column} cell={MyTimeCell} width={100} />
                    <Column field="IsReconciled" title={lang.is_reconciled_column} width={100} />


                </Grid>
            </>

            <>
                <div style={{ textAlign: 'center', fontWeight: 'bold' }}>{lang.as_run_label}</div>
                <Grid data={asRunFilterGridData.map((item) => ({
                    ...item,
                    [SELECTED_FIELD]: selectedAsRunState[idGetter(item)]
                }))}
                    selectedField={SELECTED_FIELD}
                    selectable={true}
                    dataItemKey={DATA_ITEM_KEY}
                    onSelectionChange={onAsRunSelectionChange}
                    rowRender={gridRowRender}
                    style={{ height: "95%" }}
                    ref={asRunScroll}
                    onScroll={onAsRunScroll}
                >
                    {/* <Column field="SNo" title="SNo."  width={40} /> */}
                    <GridNoRecords>{loadingStatus}</GridNoRecords>
                    <Column field="TempSNo" title={lang.sno_column} width={70} />
                    <Column field="SlotDateTime" title={lang.date_column} cell={DateOnlyCell} width={100} />
                    <Column field="SlotDateTime" title={lang.time_column} cell={MyTimeCell} width={100} />
                    <Column field="ID" title={lang.id_column || "ID"} cell={IdCell} width={150} />
                    <Column field="Title" title={lang.title_column} width={250} cell={TitleCell} />
                    <Column field="ActualDuration" title={lang.duration_column} cell={MyTimeCell} width={100} />
                    <Column field="IsReconciled" title={lang.is_reconciled_column} width={100} />
                    <Column field="Channel.SID" title={"Channel"} width={100} />
                    <Column field="" title={""} width={100} />

                </Grid>
                <ContextMenu ref={cm} model={
                    [
                        { label: `${lang.ref_force_match_label}`, icon: 'pi pi-fw pi-window-minimize', command: () => { ReconcileSelectedItems() } },
                        { label: `${lang.ref_force_unmatch_label}`, icon: 'pi pi-fw pi-window-maximize', command: () => { forceUnMatch() } },
                        { label: `${lang.ref_cancel_label}`, icon: 'pi pi-fw pi-times', command: () => { contextMenuCancel() } }
                    ]
                } />

            </>


        </Splitter>

        {showOffSetSetting && <BossDialog title={lang.offsetsetting_dialog_header} onClose={() => { setShowOffSetSetting(false); }} width={"400px"} height={"300px"}>
            <div className="row">
                <div className="col-12">
                    <EditPageHeader showTitle={false} onSubmit={onSaveOffSetSetting} onCancel={() => { setShowOffSetSetting(false); }} />
                    <div className="row mt-2">
                        <div className="col-5 mt-4">
                            <div className="form-group">
                                <label htmlFor="">{lang.offset_time_minus_label} * :</label>
                            </div>
                        </div>
                        <div className="col-7">
                            <div className="form-group">
                                <label htmlFor="">{lang.time_hh_mm_ss_ff_label}</label>
                                <TimePickerWithFormat
                                    className="form-control form-control-sm"
                                    name="OffsetTimeMinus"
                                    value={offsetdataItem.OffsetTimeMinus}
                                    onChange={onChangeOffset}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-5 mt-4">
                            <div className="form-group">
                                <label htmlFor="">{lang.offset_time_plus_label} * :</label>
                            </div>
                        </div>
                        <div className="col-7">
                            <div className="form-group">
                                <label htmlFor="">{lang.time_hh_mm_ss_ff_label}</label>
                                <TimePickerWithFormat
                                    className="form-control form-control-sm"
                                    name="OffsetTimePlus"
                                    value={offsetdataItem.OffsetTimePlus}
                                    onChange={onChangeOffset}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-5"> <label style={{ textAlign: "left", marginRight: "10px" }} htmlFor="TabView">{lang.ignore_duration_lable} :</label> </div>
                        <div className="col-2"> <input type="checkbox" name={"IgnoreDuration"} value={offsetdataItem.IgnoreDuration} checked={offsetdataItem.IgnoreDuration} onChange={onChangeOffset} /> </div>
                    </div>
                </div>
            </div>
        </BossDialog>
        }
    </div>
}

export default SecondaryEventReconciliation;